import * as React from 'react'
import { useMutation } from '@apollo/react-hooks'
import { useFormik } from 'formik'
import { Col } from 'antd'
import { colors } from 'web-makeup/dist/design-system/config/data/theme'

import { UPDATE_BRAND_PROFILE } from '../../../../../mutations/UpdateBrandProfile'
import { client as apolloClient } from '../../../../ApolloProvider/ApolloProvider'
import { Brand as BrandType } from '../../../../../typings/types'

import DefaultButton from '../../../components/DefaultButton/DefaultButton'

import {
  PageTitle,
  WhiteBox,
  InputLabel,
  Input,
  ButtonWrapper,
  StyledRow,
  TextArea,
  TagsWrapper,
  Tag,
} from '../../BrandDashboardSettings.style'

interface BrandSEODetailsFormProps {
  brandProfile?: BrandType
  brandOrderUuid?: string
}

const BrandSEODetailsForm: React.FC<BrandSEODetailsFormProps> = ({
  brandProfile,
  brandOrderUuid,
}) => {
  const [seoDeatilsInitialState, useSeoDeatilsInitialState] = React.useState({
    seoTitle: '',
    seoDescription: '',
    seoKeywords: [] as string[],
  })

  const [seoDetails, useSeoDetails] = React.useState<any>([])

  const [updateBrandProfile, { loading: brandDetailsUpdating }] = useMutation(
    UPDATE_BRAND_PROFILE,
    {
      client: apolloClient,
    }
  )

  React.useEffect(
    () => {
      useSeoDeatilsInitialState({
        seoTitle: (brandProfile && brandProfile.seoTitle) || '',
        seoDescription: (brandProfile && brandProfile.seoDescription) || '',
        seoKeywords:
          (brandProfile &&
            brandProfile.seoKeywords &&
            brandProfile.seoKeywords.toString().split(',')) ||
          [],
      })
    },
    [brandProfile]
  )

  const seoDetailsFormik = useFormik({
    initialValues: {
      ...seoDeatilsInitialState,
      seoKeywords: seoDeatilsInitialState.seoKeywords.join(),
    },
    enableReinitialize: true,
    onSubmit: values => {
      updateBrandProfile({
        variables: {
          brandUuid: brandOrderUuid,
          brandUpdateInput: {
            seoTitle: values.seoTitle,
            seoDescription: values.seoDescription,
            seoKeywords: values.seoKeywords,
          },
        },
      })
    },
  })

  const handleKeyWords = e => {
    if (e.key === ',' || e.key === 'Enter') {
      e.preventDefault()
      useSeoDeatilsInitialState({
        // ...seoDeatilsInitialState,
        seoTitle: seoDetailsFormik.values.seoTitle,
        seoDescription: seoDetailsFormik.values.seoDescription,
        seoKeywords: seoDeatilsInitialState.seoKeywords.concat([seoDetails]),
      })
      useSeoDetails('')
    }
  }
  const removeSeoKeyword = key => {
    useSeoDeatilsInitialState({
      // ...seoDeatilsInitialState,
      seoTitle: seoDetailsFormik.values.seoTitle,
      seoDescription: seoDetailsFormik.values.seoDescription,
      seoKeywords: seoDeatilsInitialState.seoKeywords.filter((item, index) => key !== index),
    })
  }
  const closeIcon = (
    <svg
      height="14"
      width="14"
      viewBox="0 0 20 20"
      aria-hidden="true"
      focusable="false"
      className="css-tj5bde-Svg"
    >
      <path d="M14.348 14.849c-0.469 0.469-1.229 0.469-1.697 0l-2.651-3.030-2.651 3.029c-0.469 0.469-1.229 0.469-1.697 0-0.469-0.469-0.469-1.229 0-1.697l2.758-3.15-2.759-3.152c-0.469-0.469-0.469-1.228 0-1.697s1.228-0.469 1.697 0l2.652 3.031 2.651-3.031c0.469-0.469 1.228-0.469 1.697 0s0.469 1.229 0 1.697l-2.758 3.152 2.758 3.15c0.469 0.469 0.469 1.229 0 1.698z" />
    </svg>
  )
  return (
    <>
      <PageTitle>Brand SEO details</PageTitle>
      <form onSubmit={seoDetailsFormik.handleSubmit}>
        <WhiteBox>
          <StyledRow type="flex">
            <Col xs={24} sm={24} md={12} lg={12}>
              <InputLabel>Title</InputLabel>
              <Input
                className={seoDetailsFormik.values.seoTitle === '' ? '' : 'filled'}
                type="text"
                placeholder="Type something"
                name="seoTitle"
                onChange={seoDetailsFormik.handleChange}
                value={seoDetailsFormik.values.seoTitle}
              />
            </Col>
          </StyledRow>
          <StyledRow type="flex">
            <Col xs={24} sm={24} md={24} lg={24}>
              <InputLabel>SEO description</InputLabel>
              <TextArea
                className={seoDetailsFormik.values.seoDescription === '' ? '' : 'filled'}
                placeholder="Type something"
                name="seoDescription"
                onChange={seoDetailsFormik.handleChange}
                value={seoDetailsFormik.values.seoDescription}
              />
            </Col>
          </StyledRow>
          <StyledRow type="flex">
            <Col xs={24} sm={24} md={12} lg={12}>
              <InputLabel>SEO Keywords</InputLabel>
              <Input
                className={seoDetailsFormik.values.seoKeywords.length > 0 ? '' : 'filled'}
                type="text"
                placeholder="Type something"
                name="seoKeywords"
                onKeyDown={e => handleKeyWords(e)}
                onChange={e => useSeoDetails(e.target.value)}
                value={seoDetails}
              />
            </Col>
            <Col xs={24} sm={24} md={24} lg={24}>
              <TagsWrapper>
                {seoDeatilsInitialState.seoKeywords &&
                  seoDeatilsInitialState.seoKeywords.length > 0 &&
                  seoDeatilsInitialState.seoKeywords
                    .toString()
                    .split(',')
                    .map((e, index) => (
                      <Tag key={index} onClick={() => removeSeoKeyword(index)}>
                        {e}
                        {closeIcon}
                      </Tag>
                    ))}
              </TagsWrapper>
            </Col>
          </StyledRow>
          <ButtonWrapper>
            <DefaultButton
              fontSize="1rem"
              padding="0 1.625rem"
              backgroundColor={colors.adaptBlue}
              style={{ marginLeft: 'auto' }}
              type="submit"
              disabled={brandDetailsUpdating}
            >
              {brandDetailsUpdating ? 'Loading...' : 'Save changes'}
            </DefaultButton>
          </ButtonWrapper>
        </WhiteBox>
      </form>
    </>
  )
}

export default BrandSEODetailsForm



// WEBPACK FOOTER //
// ./src/components/BrandDashboard/BrandDashboardSettings/forms/BrandSEODetailsForm/BrandSEODetailsForm.tsx